// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import LoanTermInput from '../loan-term';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.LOAN_TERM,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.MORTGAGE_TERM_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   valueFieldName: 'value_i',
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    // },
  },
};

const LoanTermInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <LoanTermInput
      analytics={analyticsPayload}
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default LoanTermInputWithAnalytics;
